export const SOURCE_TYPES = {
  METASEARCH: 'metasearch',
} as const
